import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import FormatTicket from "./FormatTicket";

const styles = (theme) => ({
  h1: {
    cursor: "none !important",
    color: "white",
    fontFamily: "Montserrat",
    fontSize: "1rem",
    lineHeight: "24px",
    letterSpacing: "0.02em",
    margin: 0,
    fontWeight: "600",
    marginBottom: "10px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1080)]: {
      fontSize: "18px",
      lineHeight: "27px",
    },
  },
  wrapper: {
    cursor: "none !important",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    maxWidth: "100%",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1080)]: {
      justifyContent: "center",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 450)]: {
      justifyContent: "space-around",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 370)]: {
      transform: "scale(0.9)",
      justifyContent: "space-between",
      maxWidth: "100vw",
      width: "100vw",
      marginLeft: "-1rem",
    },
  },
});

const useStyles = makeStyles(styles);

export default function FormatPicker({ state, setFormat }) {
  const classes = useStyles();
  return (
    <div>
      <h1 className={classes.h1}>Scegli un formato</h1>
      <div className={classes.wrapper}>
        <FormatTicket
          primaryDimension="15x90 cm"
          active={state === 0}
          num={0}
          handleChange={setFormat}
          secondaryDimension='6"x36"'
        />
        <FormatTicket
          primaryDimension="25x150 cm"
          active={state === 1}
          num={1}
          handleChange={setFormat}
          secondaryDimension='10"x60"'
        />
      </div>
    </div>
  );
}
